<template>
  <a-card :bordered="false">
    <SmallSquare class="m-b-24" :content="'实时概况更新时间：'+today" :padding='false'></SmallSquare>
    <a-row :gutter="[8,8]">
      <a-col :span="12">
        <div ref="chartsRef" style="width:100%;height:500px"></div>
      </a-col>
      <a-col :span="12">
        <a-row :gutter="[16,100]">
          <a-col :span="12">
            <div class="s_flex_ali">
              <div class="p-10  s_bor100 m-r-10" style="background-color:#bdbdbd">
                <img src="@/assets/images/onlineOrder/zhifu.png" alt="" class="width-50 height-50">
              </div>
              <div>
                <div>支付订单数</div>
                <div class="s_font_b fz-30">{{detail.pay_order_nums||0}}</div>
                <div>昨日全天:{{detail.yesterday_pay_order_nums||0}}</div>
              </div>
            </div>
          </a-col>
          <a-col :span="12">
            <div class="s_flex_ali">
              <div class="p-10  s_bor100 m-r-10" style="background-color:#eceff1">
                <img src="@/assets/images/onlineOrder/zongrenshu.png" alt="" class="width-50 height-50">
              </div>
              <div>
                <div>支付人数</div>
                <div class="s_font_b fz-30">{{detail.pay_user_nums||0}}</div>
                <div>昨日全天:{{detail.pay_user_nums_yesterday||0}}</div>
              </div>
            </div>
          </a-col>
          <a-col :span="12">
            <div class="s_flex_ali">
              <div class="p-10  s_bor100 m-r-10" style="background-color:#a1887f">
                <img src="@/assets/images/onlineOrder/tuikuan.png" alt="" class="width-50 height-50">
              </div>
              <div>
                <div>成功退款积分数</div>
                <div class="s_font_b fz-30">{{detail.refund_point_price||0}}</div>
                <div>昨日全天:{{detail.refund_point_price_yesterday||0}}</div>
              </div>
            </div>
          </a-col>
          <a-col :span="12">
            <div class="s_flex_ali">
              <div class="p-10 s_bFFE2DE s_bor100 m-r-10 " style="background-color:#ff7043">
                <img src="@/assets/images/onlineOrder/zhifu.png" alt="" class="width-50 height-50">
              </div>
              <div>
                <div>客单价（积分）</div>
                <div class="s_font_b fz-30">{{detail.user_unit_price||0}}</div>
                <div>昨日全天:{{detail.user_unit_price_yesterday||0}}</div>
              </div>
            </div>
          </a-col>
          <a-col :span="12">
            <div class="s_flex_ali">
              <div class="p-10  s_bor100 m-r-10" style="background-color:#f57c00">
                <img src="@/assets/images/onlineOrder/fangkeyuyue.png" alt="" class="width-50 height-50">
              </div>
              <div>
                <div>访客数</div>
                <div class="s_font_b fz-30">{{detail.uv||0}}</div>
                <div>昨日全天:{{detail.uv_yesterday||0}}</div>
              </div>
            </div>
          </a-col>
          <a-col :span="12">
            <div class="s_flex_ali">
              <div class="p-10  s_bor100 m-r-10" style="background-color:#ffb300">
                <img src="@/assets/images/onlineOrder/liulang.png" alt="" class="width-50 height-50">
              </div>
              <div>
                <div>浏览量</div>
                <div class="s_font_b fz-30">{{detail.pv||0}}</div>
                <div>昨日全天:{{detail.pv_yesterday||0}}</div>
              </div>
            </div>
          </a-col>
        </a-row>
      </a-col>
    </a-row>
  </a-card>
</template>   
<script>
import { useECharts } from "@/hooks/useECharts.js";
import { ref } from "@vue/reactivity";
import { onMounted } from "@vue/runtime-core";
import { statisticsIndex } from "@/api/online";
export default {
  setup() {
    const chartsRef = ref();
    const detail = ref({});
    const initData = async () => {
      let result = await statisticsIndex()
        .then((res) => res.data)
        .catch((error) => error);
      detail.value = result.data;
    };
    const today = ref();
    onMounted(async () => {
      var date = new Date();
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      var d = date.getDate();
      if (d == "0") {
        m = m - 1;
        var temp = new Date(y, m, d);
        d = temp.getDate();
      }
      var day = [y, m, d];
      today.value = day.join("/");
      await initData();
      var { setOptions } = useECharts(chartsRef.value);
      var values = [];
      detail.value.point_price_today_analysis.forEach((element) => {
        values.push(element);
      });
      setOptions({
        title: {
          text: "支付积分",
        },
            tooltip: {
                formatter: "{b}<br/>积分：{c}",
          trigger: "axis",
        },
        xAxis: {
          type: "category",
          data: [
            0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18,
            19, 20, 21, 22, 23,
          ],
        },
        yAxis: {
          name: "",
          type: "value",
        },
        series: [
          {
            data: values,
            type: "line",
            smooth: true,
          },
        ],
      });
    });
    return {
      chartsRef,
      detail,
      today,
    };
  },
};
</script>